import { ref, onMounted, watch } from 'vue';
import { API, graphqlOperation } from 'aws-amplify';

import { awsNow, formatSec, logintest } from '@/lib/common';
import { getRankings } from '@/lib/rankings';

import { listRecommendCourseByCompanyWithTag, getTagWithCourse, listCourseShowLogByCompanyWithTag, onCreateCompanyCourseShowLogWithTag } from '@/graphql/custom';

import { config } from '@/config';
import { User, Course } from '@/@types/d';

export const MovieFilmComponentSetup = (props:any) => {
  const rankingTypes = {
    'all': '',
    'show-recent': '最近の視聴数',
    'show-last': '前月視聴数',
    'show-all': 'トータル視聴数',
    'like-all': '評価数'
  };

  const swiper = ref<any>(null);
  const setSwiper = (obj: any) => swiper.value = obj;
  const isloading = ref(false);

  const rankings = ref();
  let isSubscribed = false;

  const currentUser = ref({} as User);
  const loggedIn = ref(false); 

  const courses = ref<Course[]>([]);

  const company = ref(props.company || '');
  const kwd = ref(props.keyword || '');
  const tagid = ref(props.tagid || '');

  const classes = ['moviefilm', 'c-sec'];
  if(props.bgDark) classes.push('u-bg02');
  if(props.keyword == 'now') {
    classes.push('no-style-viewing');
  } else if (props.keyword) {
    classes.push(`no-style-${props.keyword.toString()}`);
  }

  onMounted(() => {
    logintest(initView, clearView, {user:currentUser, state:loggedIn});
  });
  
  watch(props, () => {
    initView();
  });
  const initView = async () => {
    isloading.value = true;
    company.value = props.company;
    kwd.value = props.keyword;
    tagid.value = props.tagid;
    await queryCourses();
    // queryRanking();
    // rankings.value = await getRankings(currentUser.value.company);
    getRankings(currentUser.value.company||'', rankings);
    isloading.value = false;

    // subscribe
    if(kwd.value == 'now') subscribeCourseShowLog();
  };
  const clearView = () => {
    courses.value = [];
  };

  // course showlog の更新受取
  const subscribeCourseShowLog = async () => {
    if(isSubscribed) return;
    try {
      //@ts-ignore
      API.graphql(graphqlOperation(onCreateCompanyCourseShowLogWithTag, {companyId: currentUser.value.company})).subscribe({
        next: (d:any) => {
          if(d.value.data.onCreateCompanyCourseShowLog) {
            courses.value.unshift(d.value.data.onCreateCompanyCourseShowLog);
            if(courses.value.length >= config.MOVIEFILM_QUERYLIMIT) courses.value = courses.value.slice(0,config.MOVIEFILM_QUERYLIMIT);
          }
        }
      });
      isSubscribed = true;
    } catch(e) {
      console.warn(e);
    }
  };

  // おすすめ講座取得 query
  const queryCourses = async () => {
    if(!company.value || !kwd.value) return;

    let query = listRecommendCourseByCompanyWithTag;
    let itemName = 'listRecommendCourseByCompany';
    let params = {};

    switch(kwd.value) {
      case 'now':
        query = listCourseShowLogByCompanyWithTag;
        itemName = 'listCourseShowLogByCompany';
        params = {
          companyId: currentUser.value.company,
          sortDirection: 'DESC',
          limit: config.MOVIEFILM_QUERYLIMIT
          // limit: config.MOVIEFILM_LIMIT
        };
        break;
      case 'tag':
        if(!tagid.value) return;
        query = getTagWithCourse;
        itemName = 'getTag';
        params = {
          id: tagid.value
        };
        break;
      default:
        params = {
          companyId: company.value,
          keyword: {eq: kwd.value},
          // limit: config.MOVIEFILM_QUERYLIMIT
          limit: config.MOVIEFILM_LIMIT
        };
        break;
    }

    let res:any;
    try {
      res = await API.graphql(graphqlOperation(query, params));
    } catch(err) {
      res = err;
      console.warn(err);
    }
    if(res.data) {
      if(res.data[itemName]) {
        switch(kwd.value) {
          case 'tag':
            courses.value = res.data[itemName].courses.items;
            break;
          default:
            courses.value = res.data[itemName].items;
            break;
        }
      }
    }
  };

  const listCourses = () => {
    const r = Object.assign(courses.value)
      .filter((v:any) => v && v.course)
      .sort((a: any, b: any) => {
        if(kwd.value == 'now') {
          return b.timestamp - a.timestamp;
          // return ((a.timestamp || 0) < (b.timestamp || 0)) ? 1: -1;
        } else {
          return a.order - b.order;
          // return ((a.order || 0) > (b.order || 0)) ? 1: -1;
        }
      })
      .map((v:any) => v.course);
    return shrinkArr('id', r).slice(0, config.MOVIEFILM_LIMIT);
  };

  const shrinkArr = (key:string, arr:any[]) => {
    let r:any[] = [];
    arr.forEach((v:any) => {
      if(0 > r.findIndex((ri:any) => ri[key] == v[key])) r.push(v);
    });
    return r;
  };

  // 新着かどうか
  const isNew = (ts: number) => {
    const nt = awsNow(); 
    return (nt - ts <= config.CONTENT_NEW_PERIOD); // 1週間以内の投稿はNew
  };

  // ランキング
  const hasRank = (courseId: string) => {
    const r:any[] = [];
    if(courseId === '' || !rankings.value) return r;

    Object.keys(rankings.value).forEach((k:string) => {
      const i = rankings.value[k].findIndex((ri:any) => ri.courseId === courseId);
      //@ts-ignore
      if(i >= 0 && i <= 2) r.push(`${rankingTypes[k]}第${i+1}位`);
    });
    return r;
  }

  const swiperSlide = (direction: string) => {
    if(!swiper.value) return;
    switch(direction) {
      case 'prev':
        swiper.value.slidePrev();
        break;
      case 'next':
        swiper.value.slideNext();
        break;
      default:
        break;
    }
  };

  return {
    isloading,
    swiperSlide,
    setSwiper,
    listCourses,
    isNew,
    hasRank,
    formatSec,
    courses,
    classes
  };
};
